import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React, { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  box-shadow: 0 0 3px #04070C;\n  background-color: #04070C;\n  padding: 10px;\n  position: absolute;\n  max-width: 300px;\n  min-width: 200px;\n  top: ", ";\n  left: -30px;\n  & h1, & p {\n    color: white;\n  }\n  & h1 {\n    margin: 0px 0px 2px 0px;\n    font-weight: 900;\n    font-size: 1.2rem;\n  }\n  & p {\n    margin: 0;\n    font-size: 1.05rem;\n  }\n"])), function (props) {
  return props.height ? "-".concat(props.height + 20, "px") : '-20px';
});

var WarehouseLabel = function WarehouseLabel(_ref) {
  var title = _ref.title,
      details = _ref.details;
  var labelRef = useRef(null);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  useLayoutEffect(function () {
    if (labelRef) {
      setHeight(labelRef.current.clientHeight);
    }
  }, [labelRef]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    ref: labelRef,
    height: height
  }, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("p", null, details));
};

export default WarehouseLabel;